/**
 * `telegram` — the user's own account on this device, or a public channel without an account
 * (sources.md "telegram"). Two modes, chosen per source:
 *   account  → sources/telegram/account.ts (through `SourceRuntime.telegram`, the device's MTProto gateway)
 *   public   → sources/telegram/public.ts  (the t.me/s/<name> web preview, through the relay)
 * Without a gateway (no Telegram API id in this build) account mode reports `unsupported`; public works.
 */

import type { SourceClient } from '../contracts/sources.js';
import { fetchAccount, resolveAccount } from './telegram/account.js';
import { fetchPublic, parsePublicAddress, resolvePublic } from './telegram/public.js';

export const telegramClient: SourceClient<'telegram'> = {
  kind: 'telegram',
  defaultPullMinutes: 10,

  async resolve(input, runtime) {
    const mode = input.config?.mode ?? (input.config?.peerId ? 'account' : parsePublicAddress(input.address) ? 'public' : 'account');
    return mode === 'account' ? resolveAccount(input.address, input.config, runtime) : resolvePublic(input.address, runtime);
  },

  async fetch(ctx) {
    return ctx.source.config.mode === 'account' ? fetchAccount(ctx) : fetchPublic(ctx);
  },
};
